const Event = () => {
  const certiList = [
    "/images/certification1.png",
    "/images/certification2.png",
    "/images/certification3.png",
    "/images/certification4.png",
  ];
  return (
    <div
      id="event"
      className="relative w-full h-full lg:px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center"
    >
      {/* Heading */}
      <div className="text-center">
        <p className="font-light lg:text-2xl">
          무조건 <span className="text-primary">싸게</span>만 해준다고 하는
          업체가 있으셨나요?
        </p>
        <h2 className="mt-2 text-3xl md:text-4xl xl:text-5xl">
          <span className="font-light">
            작업도중 <span className="text-primary">추가요금을 요청</span>
            할&nbsp;수도&nbsp;있습니다!
          </span>
        </h2>
        <p className="lg:text-lg">
          <span className="text-primary">다양한 자격증을 갖춘</span> 전문업체
          바우하우스에서 제대로&nbsp;견적&nbsp;받아보세요
        </p>
      </div>

      <div
        data-aos="fade-up"
        className="relative w-full h-full mx-auto mt-12 grid grid-cols-2 lg:grid-cols-4 bg-light p-5 gap-5 lg:p-10"
      >
        {certiList.map((v, i) => (
          <div>
            <img src={v} alt="방역관리 자격증" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Event;
